export default {
  accountConfig: [],

  commodityCategories: [],
  commodityCategoryCode: null,

  commodity: [],
  commodityMaxCode: null,
  commodityById: [],

  dealType: [],
  dealTypeById: {},

  cottage: [],
  cottageMaxCode: null,
  cottageById: {},

  purchase: [],
  purchaseById: {},

  order: [],
  orderMaxCode: null,
  orderById: {},

  lading : [],
  ladingById : {},

  cottageReport : [],
  purchaseReport : [],
  orderReport : [],
  comprehensiveOrderReport : [],
};
